import { render } from "./HomeSynergy.vue?vue&type=template&id=a3c76dc2&scoped=true"
import script from "./HomeSynergy.vue?vue&type=script&lang=js"
export * from "./HomeSynergy.vue?vue&type=script&lang=js"

import "./HomeSynergy.vue?vue&type=style&index=0&id=a3c76dc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3c76dc2"]])

export default __exports__